import Script from "next/script";

import {
  AUTO_BLOCK_SCRIPT_URL,
  DATA_DOMAIN_SCRIPT_ID,
  SDK_SCRIPT_URL,
} from "./constants";

export const setupScripts = [
  <Script
    key="onetrust-autoblock-script"
    src={AUTO_BLOCK_SCRIPT_URL}
    strategy="beforeInteractive"
  />,
  <Script
    key="onetrust-cookies-manager-script"
    src={SDK_SCRIPT_URL}
    data-domain-script={DATA_DOMAIN_SCRIPT_ID}
    strategy="beforeInteractive"
  />,
  <Script
    key="onetrust-optanon-event-handler"
    id="dispatch-onetrust-onready-event"
    strategy="beforeInteractive"
    dangerouslySetInnerHTML={{
      __html: `
      function OptanonWrapper() {
        window.dispatchEvent(new Event("onOneTrustReady"));
      };
    `,
    }}
  />,
  <Script
    key="setup-scripts-gtag-GTM-TZ2QQPXL"
    id="setup-scripts-gtag-GTM-TZ2QQPXL-script"
    strategy="beforeInteractive"
    dangerouslySetInnerHTML={{
      __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-TZ2QQPXL');
          `,
    }}
  />,
];
